<template>
  <div class="minichat-wrapper">
    <transition
      enter-active-class="animate__animated animate__zoomIn animate__faster"
      leave-active-class="animate__animated animate__zoomOut animate__faster"
    >
      <div
        v-if="callout"
        class="callout d-flex align-items-center justify-content-center p-2"
      >
        <span>{{ msg }}</span>
      </div>
    </transition>
    <div
      class="agentphoto cursor-pointer"
      :style="{
        backgroundImage: `url(${agentPhoto})`,
      }"
      @click="activate"
      :class="{ inactive: !active }"
    >
      <div class="agentphoto-overlay"></div>
    </div>
    <div class="minichat-menu">
      <iconsvg
        @click="toggleMenu"
        name="pluscircle"
        :color="colors.iconcolor"
      ></iconsvg>

      <transition
        enter-active-class="animate__animated animate__zoomIn"
        leave-active-class="animate__animated animate__zoomOut"
      >
        <div
          class="ul d-flex flex-column gap-2 justify-content-evenly"
          v-if="showmenu"
          v-click-outside="toggleMenu"
          style="transform-origin: bottom right"
        >
          <div class="close-wrapper">
            <i
              class="icon-close"
              :style="{ '--pseudo-color': colors.iconcolor }"
              @click="toggleMenu"
            ></i>
          </div>
          <div class="li d-flex align-items-center gap-2" @click="openMainChat">
            <iconsvg name="arrowright" :color="colors.iconcolor"></iconsvg>
            <span>{{ lang.open_chat }}</span>
          </div>
          <transition
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
            mode="out-in"
          >
            <div
              v-if="active"
              class="li d-flex align-items-center gap-2"
              @click="deactivate"
            >
              <iconsvg name="micmute" :color="colors.iconcolor"></iconsvg>
              <span>{{ lang.deactivate }}</span>
            </div>
            <div
              v-else
              class="li d-flex align-items-center gap-2"
              @click="activate"
            >
              <iconsvg name="micunmute" :color="colors.iconcolor"></iconsvg>
              <span>{{ lang.activate }}</span>
            </div>
          </transition>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, toRef, watch } from "vue";
import iconsvg from "./iconsvg.vue";
export default {
  components: { iconsvg },
  emits: ["openChat", "deactivateVoiceMode", "activateVoiceMode"],
  props: {
    colors: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
      default: true,
    },
    mini_msg: {
      type: String,
      default: "",
    },
    thinking: {
      type: Boolean,
      default: false,
    },
    agent_photo_url: {
      type: String,
      default: "",
      required: true,
    },
    lang: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const assetUrl = process.env.VUE_APP_ASSET_URL;
    const agentPhoto = ref(`${assetUrl}/img/clara.png`);

    const showmenu = ref(false);
    const msg = ref("");
    const miniMsgRef = toRef(props, "mini_msg");
    const activeRef = toRef(props, "active");
    const callout = ref(false);
    const calloutTimeout = ref(null);
    const agent_photo_ref = toRef(props, "agent_photo_url");
    const toggleMenu = () => {
      showmenu.value = !showmenu.value;
    };
    const openMainChat = () => {
      emit("openChat");
    };
    const deactivate = () => {
      if (props.active) {
        emit("deactivateVoiceMode");
        toggleMenu();
      }
    };
    const activate = () => {
      if (!props.active) {
        emit("activateVoiceMode");
        showmenu.value = false;
      }
    };

    watch(agent_photo_ref, (current_val) => {
      agentPhoto.value = current_val;
    });
    watch(miniMsgRef, (current_val) => {
      msg.value = current_val;
      callout.value = true;
      clearTimeout(calloutTimeout.value);
      calloutTimeout.value = setTimeout(() => {
        callout.value = false;
      }, 20000);
    });

    watch(activeRef, (current_val) => {
      if (current_val == false) callout.value = false;
    });
    onMounted(() => {
      agentPhoto.value = agent_photo_ref.value;
    });
    return {
      agentPhoto,
      showmenu,
      toggleMenu,
      openMainChat,
      deactivate,
      activate,
      msg,
      callout,
    };
  },
};
</script>

<style scoped>
.icon-close:after {
  background-color: var(--pseudo-color);
}
.icon-close:before {
  background-color: var(--pseudo-color);
}
.close-wrapper {
  top: 2px;
  right: 2px;
}
</style>
